export default function extractErrorMessage(err: unknown): string {
  return err instanceof Error
    ? err.message
    : typeof err === 'string'
      ? err
      : JSON.stringify(err);
}
